import "./OrderIcon.css";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

import { OrderStatus } from "../admin/editCasePanel/Orders.helpers";

interface OrderIconProps {
  status: OrderStatus;
  className?: string;
}

const mapOrderStatusToIcon: { [key in OrderStatus]: string } = {
  complete: "circle-check", // #006400
  cancelled: "circle-minus", // var(--steel)
  in_progress: "circle-play", // #daa520
};

export const OrderIcon: React.FC<OrderIconProps> = ({
  status,
  className,
  ...rest
}) => {
  const props = {
    ...rest,
    className: classNames("OrderIcon", `OrderIcon--${status}`, className),
    icon: mapOrderStatusToIcon[status] as IconProp,
  };

  return <FontAwesomeIcon {...props} />;
};

export default OrderIcon;
